import ProfileComponent
  from "../lib/bandung/components/Profile/ProfileComponent";
import { Stack } from "@mui/material";
import { useTheme } from "../components/Theme";

export default function Profile () {
  const { darkMode, toggleModes } = useTheme();

  const layoutClasses = darkMode 
  ? "bg-slate-500 text-white "  
  : "bg-white-800 text-black ";

    return (
      <>
            <div className="login-page-wrapper w-full py-10">
                <div className="container-x mx-auto">
                  <Stack alignItems={"center"}
                         justifyContent={"center"}
                         width={"100%"}
                         margin={"2em 0"}
                         >
                    <ProfileComponent />
                  </Stack>
                </div>
            </div>
      </>
    ) ;
}
